<template>
	<div class="main-content" v-loading="loading">
		<div class="paysuccess" v-if="!loading">
			<div class="p10">订单提交成功</div>
			<div class="order-info">
				<div class><span class="el-icon-success"></span> 订单提交成功！网上订单编号：{{dataInfo.order_no}}</div>
				<div>
					<!-- <button class="bnt-buy"> -->
						<router-link to="cat" class="bnt-buy">继续购买</router-link>
					<!-- </button> -->
					<!-- <button class="bnt-submit"> -->
						<router-link to="order-list" class="bnt-submit">查看我的订单</router-link>
					<!-- </button> -->
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'paysuccess',
		data() {
			return {
				dataInfo: {},
				loading: true
			}
		},
		created: function() {
			this.id = this.$route.query.id;
			this.reload();
		},
		methods: {
			reload: function() {
				var params = {
					id: this.id
				}
				this.https.fetchGet('/pc/service/trade/order/details', params)
					.then((res) => {
						if (res.data.success) {
							var data = res.data.content;
							this.dataInfo = data;
							this.loading = false;
						}

					}).catch(err => {
						console.log(err)
					})
			},
		},
	}
</script>

<style scoped="">
	.paysuccess {
		padding: 40px;
	}

	.p10 {
		padding: 10px;
	}

	.order-info {
		display: flex;
		align-items: center;
		padding: 20px;
		background: #fff;
		justify-content: space-between;
	}

	.el-icon-success {
		color: rgb(0, 150, 136);
		font-size: 30px;
		margin-right: 20px;
		vertical-align: middle;
	}

	.bnt-buy {
		background: rgb(74, 144, 138);
		color: #fff;
		border: 0;
		padding: 10px 30px;
		cursor: pointer;
		border-radius: 5px;
	}

	.bnt-submit {
		background: rgb(63, 118, 181);
		color: #fff;
		border: 0;
		padding: 10px 30px;
		cursor: pointer;
		border-radius: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/views/paysuccess.vue